function fulfilled(i, promises, values, fnFinally) {
	return (value) => {
		values.push(value);
		if(!!promises[i + 1]) {
			if(angular.isFunction(promises[i + 1])) {
				promises[i + 1].call(null).then(
					fulfilled(i + 1, promises, values, fnFinally),
					failed
				);
			}
			else {
				var idx = i + 1;
				var end = false;
				while(!angular.isFunction(promises[idx]) && !end) {
					values.push(promises[idx]);
					idx++;
					if(promises.length <= idx) {
						end = true;
					}
				}

				if(end) {
					fnFinally.call(null, values);
				}
				else {
					promises[idx].call(null).then(
						fulfilled(idx, promises, values, fnFinally),
						failed
					);
				}
			}
		}
		else {
			fnFinally.call(null, values);
		}

	}
}

function failed(a,b,c) {
	console.log('error', a,b,c);
}

class UtilityService {
	static promiseForceAll($q, promises) {
		var deferred = $q.defer();

		promises[0].call(null).then(fulfilled(0, promises, [], (values) => {
			deferred.resolve(values);
		}));

		return deferred.promise;
	}
}

export default UtilityService;


// WEBPACK FOOTER //
// ./resources/WEB-INF/script/service/service.utility.es6.js